import {
  mdiHomeOutline,
  mdiFileDocumentMultipleOutline,
  mdiSchool,
  mdiVideoVintage,
  mdiFileChartOutline
} from '@mdi/js'

export default [

  // { title: 'common.home', icon: mdiHomeOutline, to: 'home' },
  { title: 'common.reports', icon: mdiFileChartOutline, to: 'reports' },
  {subheader: 'common.eval_subheader' },
  { title: 'common.qip', icon: mdiFileDocumentMultipleOutline, to: 'evaluations' },
  {subheader: '' },
  { title: 'common.schools', icon: mdiSchool, to: 'schools' },
  // {subheader: 'FAQs' },
  // { title: 'Tutorial', icon: mdiVideoVintage, to: 'tutorial' },

]
